module.exports = __webpack_public_path__ + "img/thumbfield2.33a6017c.png";